module.exports = __webpack_public_path__ + "static/media/vector2Gem.4d0d5884.svg";